import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { timeChipSx } from './tableChipStyles';

// ==============================|| TABLE TIME CHIPS ||============================== //

export default function TableTimeChips({ times = [], formatTime }) {
  if (!times?.length) {
    return <Chip label="All Day" size="small" sx={timeChipSx} />;
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {times.map((t, i) => (
        <Chip
          key={t.id ?? i}
          label={`${formatTime(t.from_time)} – ${formatTime(t.to_time)}`}
          size="small"
          sx={timeChipSx}
        />
      ))}
    </Stack>
  );
}

TableTimeChips.propTypes = {
  times: PropTypes.array,
  formatTime: PropTypes.func.isRequired
};
